import PropTypes from 'prop-types';
import React from 'react';

import FieldLabel from './FieldLabel';
import HiddenInputs from './HiddenInputs';
import Flatpickr from "react-flatpickr";

const DateTimeField = ({
  customFieldValue,
  index,
  inputFieldChanged,
  disabled
}) => (
  <div className="form-group">
    <FieldLabel index={index}
                customFieldValue={customFieldValue} />
    <HiddenInputs index={index}
                  customFieldValue={customFieldValue} />
    <input type="hidden"
           name={"task_completion[custom_field_values_attributes][" + index + "][type]"}
           value={"CustomFieldValues::Text"} />
    <Flatpickr
      data-enable-time
      disabled={disabled}
      options={{
        dateFormat: "F j, Y - h:i K"
      }}
      id={"custom-field-value-" + index}
      name={"task_completion[custom_field_values_attributes][" + index + "][value]"}
      value={customFieldValue.value || ""}
      onChange={
        (dates) => {
          inputFieldChanged(index, (dates[0] || ""));
        }
      }
      style={{"maxWidth": "400px"}}
      className="form-control"
    />
  </div>
);

DateTimeField.propTypes = {
  customFieldValue: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  inputFieldChanged: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default DateTimeField;
